import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "./baseQuery";

export const homeApi = createApi({
  reducerPath: "homeApi",
  baseQuery,
  tagTypes: ['MaintenanceMessage', 'ReleaseNotes', 'SidebarMenuPreferences', 'HomePagePreferences'],
  endpoints: (builder) => ({
    // Existing endpoints
    getCountData: builder.query({
      query: ({ site }) => ({
        url: `/getAlarmsCount/?site=${site}`,
        method: "GET"
      }),
    }),
    getOutageData: builder.query({
      query: () => ({
        url: `/getOutages/`,
        method: "GET"
      }),
    }),

    // https://www.jmareports.com/home/api/getOutages/
    getAvailability: builder.query({
      query: () => ({
        url: `/getAvailability/`,
        method: "GET"
      }),
    }),
    getGraphData: builder.query({
      query: ({ site, dbDates }) => {
        let url = `/getGraph/?site=${site}&start_date=${dbDates?.start}&end_date=${dbDates?.end}`;
        return {
          url,
          method: "GET",
        };
      },
    }),
    getCSVData: builder.query({
      query: ({ site, start, end }) => {
        let url = `getCSV/?site=${site}&start_date=${start}&end_date=${end}`;
        return {
          url,
          method: "GET",
        };
      },
    }),

    addGroup: builder.mutation({
      query: ({ body }) => ({
        url: `/djangoGroupsMapping/`,
        method: "POST",
        body: body
      }),
    }),
    getSuData: builder.query({
      query: ({ site, start, end }) => {
        let url = `/getdata/?site=${site}`;
        console.log('urlwithoutDateRange', url);
        if (start && end) {
          url = `/getDataDB/?site=${site}&start_date=${start}&end_date=${end}`;
        }
        return {
          url,
          method: "GET",
        };
      },
    }),

    // Shift Scheduling API - Teams
    getTeams: builder.query({
      query: () => ({
        url: `/teams/`,
        method: "GET"
      }),
    }),
    getTeam: builder.query({
      query: ({ id }) => ({
        url: `/teams/${id}/`,
        method: "GET"
      }),
    }),
    addTeam: builder.mutation({
      query: ({ body }) => ({
        url: `/teams/`,
        method: "POST",
        body
      }),
    }),
    updateTeam: builder.mutation({
      query: ({ id, body }) => ({
        url: `/teams/${id}/`,
        method: "PUT",
        body
      }),
    }),
    deleteTeam: builder.mutation({
      query: ({ id }) => ({
        url: `/teams/${id}/`,
        method: "DELETE"
      }),
    }),

    // Shift Scheduling API - Shifts
    getShifts: builder.query({
      query: () => ({
        url: `/shifts/`,
        method: "GET"
      }),
    }),
    getShift: builder.query({
      query: ({ id }) => ({
        url: `/shifts/${id}/`,
        method: "GET"
      }),
    }),
    addShift: builder.mutation({
      query: ({ body }) => ({
        url: `/shifts/`,
        method: "POST",
        body
      }),
    }),
    updateShift: builder.mutation({
      query: ({ id, body }) => ({
        url: `/shifts/${id}/`,
        method: "PUT",
        body
      }),
    }),
    deleteShift: builder.mutation({
      query: ({ id }) => ({
        url: `/shifts/${id}/`,
        method: "DELETE"
      }),
    }),

    // Shift Scheduling API - Shift Assignments
    getShiftAssignments: builder.query({
      query: (params) => {
        const queryString = new URLSearchParams(params).toString();
        return {
          url: `/shift-assignments/?${queryString}`,
          method: "GET"
        };
      },
    }),
    getShiftAssignmentsByDateRange: builder.query({
      query: ({ start_date, end_date }) => ({
        url: `/shift-assignments/by_date_range/?start_date=${start_date}&end_date=${end_date}`,
        method: "GET"
      }),
    }),
    getShiftAssignmentsByUser: builder.query({
      query: ({ user_id, start_date, end_date }) => {
        let url = `/shift-assignments/by_user/?user_id=${user_id}`;
        if (start_date) url += `&start_date=${start_date}`;
        if (end_date) url += `&end_date=${end_date}`;
        return {
          url,
          method: "GET"
        };
      },
    }),
    getShiftAssignmentsByTeam: builder.query({
      query: ({ team_id, start_date, end_date }) => {
        let url = `/shift-assignments/by_team/?team_id=${team_id}`;
        if (start_date) url += `&start_date=${start_date}`;
        if (end_date) url += `&end_date=${end_date}`;
        return {
          url,
          method: "GET"
        };
      },
    }),
    getShiftAssignment: builder.query({
      query: ({ id }) => ({
        url: `/shift-assignments/${id}/`,
        method: "GET"
      }),
    }),
    addShiftAssignment: builder.mutation({
      query: ({ body }) => ({
        url: `/shift-assignments/`,
        method: "POST",
        body
      }),
    }),
    updateShiftAssignment: builder.mutation({
      query: ({ id, body }) => ({
        url: `/shift-assignments/${id}/`,
        method: "PUT",
        body
      }),
    }),
    deleteShiftAssignment: builder.mutation({
      query: ({ id }) => ({
        url: `/shift-assignments/${id}/`,
        method: "DELETE"
      }),
    }),

    // Shift Scheduling API - Time Off
    getTimeOff: builder.query({
      query: (params) => {
        const queryString = new URLSearchParams(params).toString();
        return {
          url: `/time-off/?${queryString}`,
          method: "GET"
        };
      },
    }),
    getActiveTimeOffByDate: builder.query({
      query: ({ date }) => ({
        url: `/time-off/active_by_date/?date=${date}`,
        method: "GET"
      }),
    }),
    getTimeOffByUser: builder.query({
      query: ({ user_id, start_date, end_date }) => {
        let url = `/time-off/by_user/?user_id=${user_id}`;
        if (start_date) url += `&start_date=${start_date}`;
        if (end_date) url += `&end_date=${end_date}`;
        return {
          url,
          method: "GET"
        };
      },
    }),
    getTimeOffRecord: builder.query({
      query: ({ id }) => ({
        url: `/time-off/${id}/`,
        method: "GET"
      }),
    }),
    addTimeOff: builder.mutation({
      query: ({ body }) => ({
        url: `/time-off/`,
        method: "POST",
        body
      }),
    }),
    updateTimeOff: builder.mutation({
      query: ({ id, body }) => ({
        url: `/time-off/${id}/`,
        method: "PUT",
        body
      }),
    }),
    deleteTimeOff: builder.mutation({
      query: ({ id }) => ({
        url: `/time-off/${id}/`,
        method: "DELETE"
      }),
    }),
    getLoginTracking: builder.query({
      query: () => ({
        url: `/getLoginTracking/`,
        method: "GET"
      }),
    }),

    getDataRequest: builder.query({
      query: ({ group_id, tag_value }) => ({
        url: `/getDataRequest/?group_id=${group_id}&tag_value=${tag_value}`,
        method: "GET"
      }),
    }),

    getDataRequestCSV: builder.query({
      query: ({ group_id, tag_value }) => ({
        url: `/getDataRequestCSV/?group_id=${group_id}&tag_value=${tag_value}`,
        method: "GET",
        responseHandler: (response) => response.blob(),
      }),
    }),

    getOutageTracker: builder.query({
      query: ({ year, month } = {}) => {
        const params = new URLSearchParams();
        if (year) params.set("year", String(year));
        if (month) params.set("month", String(month));
        const queryString = params.toString();
        return {
          url: `/getOutageTracker/${queryString ? `?${queryString}` : ""}`,
          method: "GET"
        };
      },
    }),

    updateOutageTracker: builder.mutation({
      query: ({ id, reason, owner, modified_by }) => ({
        url: `/updateOutageTracker/`,
        method: "POST",
        body: { id, reason, owner, modified_by }
      }),
    }),

    getNocHw: builder.query({
      query: () => ({
        url: `/getNocHw/`,
        method: "GET"
      }),
    }),

    // XRAN Tracking endpoints
    getXranHeaders: builder.query({
      query: () => ({
        url: `/xran-tracking/getHeaders/`,
        method: "GET"
      }),
    }),

    getXranSystems: builder.query({
      query: () => ({
        url: `/xran-tracking/getSystems/`,
        method: "GET"
      }),
    }),

    updateXranField: builder.mutation({
      query: ({ id, field, newvalue }) => ({
        url: `/xran-tracking/updateField/`,
        method: "POST",
        body: { id, field, newvalue }
      }),
    }),

    deleteXranSystem: builder.mutation({
      query: ({ id }) => ({
        url: `/xran-tracking/deleteSystem/`,
        method: "POST",
        body: { id }
      }),
    }),

    createXranSystem: builder.mutation({
      query: (systemData) => ({
        url: `/xran-tracking/createSystem/`,
        method: "POST",
        body: systemData
      }),
    }),

    getXranUpgradeStatus: builder.query({
      query: () => ({
        url: `/xran-tracking/getUpgradeStatus/`,
        method: "GET"
      }),
    }),

    getXranColumnPreferences: builder.query({
      query: ({ userIdentifier, pageKey = 'xran-tracking' }) => ({
        url: `/xran-tracking/preferences/?user_identifier=${encodeURIComponent(userIdentifier)}&page_key=${encodeURIComponent(pageKey)}`,
        method: "GET",
      }),
    }),

    upsertXranColumnPreferences: builder.mutation({
      query: ({ userIdentifier, pageKey = 'xran-tracking', visibleColumns }) => ({
        url: `/xran-tracking/preferences/`,
        method: "PUT",
        body: {
          user_identifier: userIdentifier,
          page_key: pageKey,
          visible_columns: visibleColumns,
        },
      }),
    }),

    getSidebarMenuPreferences: builder.query({
      query: ({ userIdentifier }) => ({
        url: `/sidebar-menu/preferences/?user_identifier=${encodeURIComponent(userIdentifier)}`,
        method: "GET",
      }),
      providesTags: (_result, _error, { userIdentifier }) => [
        { type: 'SidebarMenuPreferences', id: userIdentifier },
      ],
    }),

    upsertSidebarMenuPreferences: builder.mutation({
      query: ({ userIdentifier, menuItems }) => ({
        url: `/sidebar-menu/preferences/`,
        method: "PUT",
        headers: { 'X-User-Sub': userIdentifier },
        body: { menu_items: menuItems },
      }),
      invalidatesTags: (_result, error, { userIdentifier }) => error ? [] : [
        { type: 'SidebarMenuPreferences', id: userIdentifier },
      ],
    }),

    getHomePagePreferences: builder.query({
      query: ({ userIdentifier }) => ({
        url: `/home-page/preferences/?user_identifier=${encodeURIComponent(userIdentifier)}`,
        method: "GET",
      }),
      providesTags: (_result, _error, { userIdentifier }) => [
        { type: 'HomePagePreferences', id: userIdentifier },
      ],
    }),

    upsertHomePagePreferences: builder.mutation({
      query: ({ userIdentifier, homeItems }) => ({
        url: `/home-page/preferences/`,
        method: "PUT",
        headers: { 'X-User-Sub': userIdentifier },
        body: { home_items: homeItems },
      }),
      invalidatesTags: (_result, error, { userIdentifier }) => error ? [] : [
        { type: 'HomePagePreferences', id: userIdentifier },
      ],
    }),

    reportError: builder.mutation({
      query: (body) => ({
        url: `/reportError/`,
        method: "POST",
        body,
      }),
    }),

    getKpiDashboard: builder.query({
      query: ({ siteKey, from, to, maxDataPoints = 1200 }) => {
        const params = new URLSearchParams({
          site: siteKey,
          from: String(from),
          to: String(to),
          maxDataPoints: String(maxDataPoints),
        });
        return {
          url: `/getKpiDashboard/?${params.toString()}`,
          method: "GET",
        };
      },
      keepUnusedDataFor: 30,
    }),

    getSuBuildingData: builder.query({
      query: ({ startDate, endDate, buildings = [] }) => {
        const params = new URLSearchParams({
          start_date: startDate,
          end_date: endDate,
        });
        buildings.forEach((building) => params.append('building', building));
        return {
          url: `/getSUBuildingData/?${params.toString()}`,
          method: "GET",
        };
      },
      keepUnusedDataFor: 60,
    }),

    // Maintenance Message endpoints
    getMaintenanceMessage: builder.query({
      query: () => ({
        url: `/getMaintenanceMessage/`,
        method: "GET",
      }),
      providesTags: ['MaintenanceMessage'],
    }),
    setMaintenanceMessage: builder.mutation({
      query: (body) => ({
        url: `/setMaintenanceMessage/`,
        method: "POST",
        body,
      }),
      invalidatesTags: ['MaintenanceMessage', 'ReleaseNotes'],
    }),
    getReleaseNotes: builder.query({
      query: ({ limit = 20, offset = 0 } = {}) => ({
        url: `/getReleaseNotes/?limit=${limit}&offset=${offset}`,
        method: "GET",
      }),
      providesTags: ['ReleaseNotes'],
    }),

    getXranCerts: builder.query({
      query: (params = {}) => {
        const filtered = Object.fromEntries(
          Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== '')
        );
        const queryString = new URLSearchParams(filtered).toString();
        return {
          url: `/getXranCerts/${queryString ? `?${queryString}` : ''}`,
          method: "GET",
        };
      },
    }),

    // Campus Map - Building Coordinates and Status
    getCampusBuildings: builder.query({
      query: () => ({
        url: `/getSUBuildingsHostCoordinates/`,
        method: "GET"
      }),
      // Cache for 5 minutes since buildings don't change often
      keepUnusedDataFor: 300,
    }),

    getCampusStatuses: builder.query({
      query: () => ({
        url: `/getSUBuildingsHostCoordinates/`,
        method: "GET"
      }),
      // Don't cache - always fresh for polling
      keepUnusedDataFor: 0,
    }),
  }),
});


export const {
  useGetCountDataQuery,
  useGetOutageDataQuery,
  useLazyGetSuDataWithDateFilterQuery,
  useLazyGetSuDataQuery,
  useLazyGetGraphDataQuery,
  useLazyGetCSVDataQuery,
  useLazyGetNobuDataWithDateFilterQuery,
  useLazyGetNobuDataQuery,
  useAddGroupMutation,
  useGetAvailabilityQuery,
  // Teams
  useGetTeamsQuery,
  useGetTeamQuery,
  useLazyGetTeamQuery,
  useAddTeamMutation,
  useUpdateTeamMutation,
  useDeleteTeamMutation,
  // Shifts
  useGetShiftsQuery,
  useGetShiftQuery,
  useAddShiftMutation,
  useUpdateShiftMutation,
  useDeleteShiftMutation,
  // Shift Assignments
  useGetShiftAssignmentsQuery,
  useGetShiftAssignmentsByDateRangeQuery,
  useGetShiftAssignmentsByUserQuery,
  useGetShiftAssignmentsByTeamQuery,
  useGetShiftAssignmentQuery,
  useAddShiftAssignmentMutation,
  useUpdateShiftAssignmentMutation,
  useDeleteShiftAssignmentMutation,
  // Time Off
  useGetTimeOffQuery,
  useGetActiveTimeOffByDateQuery,
  useGetTimeOffByUserQuery,
  useGetTimeOffRecordQuery,
  useAddTimeOffMutation,
  useUpdateTimeOffMutation,
  useDeleteTimeOffMutation,
  useGetLoginTrackingQuery,
  useLazyGetDataRequestQuery,
  useLazyGetDataRequestCSVQuery,
  useGetOutageTrackerQuery,
  useUpdateOutageTrackerMutation,
  useGetNocHwQuery,
  useGetXranHeadersQuery,
  useGetXranSystemsQuery,
  useUpdateXranFieldMutation,
  useDeleteXranSystemMutation,
  useCreateXranSystemMutation,
  useGetXranUpgradeStatusQuery,
  useGetXranColumnPreferencesQuery,
  useUpsertXranColumnPreferencesMutation,
  useGetSidebarMenuPreferencesQuery,
  useUpsertSidebarMenuPreferencesMutation,
  useGetHomePagePreferencesQuery,
  useUpsertHomePagePreferencesMutation,
  useReportErrorMutation,
  useGetKpiDashboardQuery,
  useGetSuBuildingDataQuery,
  // Maintenance / Release Notes
  useGetMaintenanceMessageQuery,
  useSetMaintenanceMessageMutation,
  useGetReleaseNotesQuery,
  useGetXranCertsQuery,
  // Campus Map
  useGetCampusBuildingsQuery,
  useGetCampusStatusesQuery,
} = homeApi;
